export default __webpack_public_path__ + "static/media/garware-sun-control-film.030ba7d3.jpg";